<script>
import { mapGetters, mapMutations, mapActions } from 'vuex';

export default {

    methods: {
        async thisRequest(){
            var route = this.$route.query
            var params = {}
            if(this.$store.state.user.user.role.is_supervisor){
                params= {
                    study_year:route.study_year,
                    study_plan:route.study_plan,
                    acad_period:route.acad_period,
                    student:route.student
                }
            }else{
                params= {
                    study_year:route.study_year,
                    study_plan:route.study_plan,
                    acad_period:route.acad_period,
                }
            }
            await this.$http.get('user/vputi_discipline_student/', {
                params: params}).then(async res=>
            {
                if(res.data.length == 0){
                    this.data = undefined
                }else{
                    this.data = res.data
                }
            }
            )
        },
    },
}
</script>
